module.exports = __webpack_public_path__ + "img/remote_work.5678b980.jpg";